const programme = {
  name: "programme",
  label: "Programme",
  editor: {
    preview: false,
  },
  description: "Programme Night",
  folder: "content/programme",
  slug: "{{title}}",
  create: true,
  fields: [
    {
      name: "template",
      widget: "hidden",
      default: "programme",
      required: true,
    },
    {
      name: "title",
      widget: "string",
      label: "Date",
      description: "Please enter a date in the format yyyy-MM-DD.",
      required: true,
      pattern: ["^\\d{4}-\\d{2}-\\d{2}$", "Use the format YYYY-MM-DD"],
      hint: "Please enter a date in the format YYYY-MM-DD.",
    },
    {
      label: "Uniform?",
      name: "uniform",
      required: true,
      widget: "relation",
      collection: "prog_settings",
      file: "prog_settings",
      search_fields: ["uniforms.*.uniform"],
      display_fields: ["uniforms.*.uniform"],
      value_field: "uniforms.*.uniform",
    },
    {
      label: "Activity",
      name: "activity",
      summary: "{{fields.group}} - {{fields.activity}}",
      widget: "list",
      collapsed: true,
      fields: [
        {
          label: "Should this activity be for everyone?",
          name: "everyone",
          widget: "boolean",
          default: false,
        },
        {
          label: "Which Group of Cadets should undertake this activity?",
          name: "group",
          required: false,
          widget: "relation",
          collection: "prog_settings",
          file: "prog_settings",
          search_fields: ["groups.*.group"],
          display_fields: ["groups.*.group"],
          value_field: "groups.*.group",
        },
        {
          label: "Choose an activity from this list",
          name: "activity",
          widget: "relation",
          collection: "prog_settings",
          file: "prog_settings",
          search_fields: ["activities.*.activity"],
          display_fields: ["activities.*.activity"],
          value_field: "activities.*.activity",
          required: false,
        },
        {
          label: "Or create a one-off activity",
          name: "activity-new",
          widget: "string",
          required: false,
        },
        {
          required: false,
          label: "Instructor",
          name: "instructor",
          widget: "relation",
          collection: "prog_settings",
          file: "prog_settings",
          search_fields: ["instructors.*.instructor"],
          display_fields: ["instructors.*.instructor"],
          value_field: "instructors.*.instructor",
        },
      ],
    },
  ],
};

export default programme;
